<template>
  <div class="wrapper">
    <side-bar v-show="$sidebar.showSidebar">
      <template slot="links">
        <sidebar-link
          to="/bgp-monitor"
          name="BGP Monitor"
          icon="tim-icons icon-world"
        />
      </template>
    </side-bar>
    <div class="main-panel" :class="{ 'sidebar-hidden': !$sidebar.showSidebar }">
      <top-navbar></top-navbar>

      <dashboard-content> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
// When sidebar is hidden, main panel should use full width
.main-panel.sidebar-hidden > .content {
  padding-left: 30px !important;
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
  },
  mounted() {
    // Initialize sidebar as visible by default
    if (this.$sidebar.showSidebar === undefined || this.$sidebar.showSidebar === null) {
      this.$sidebar.displaySidebar(true);
    }
  },
};
</script>
